import React from 'react';
import styled from 'styled-components';
import { sortBy } from 'lodash';
import { sortingLowerCase } from '../services/I2P2Helper';
import { chargerStatuses, monitoredStatuses, conditionStatuses, allChargerStatuses } from './statuses';
import { StatusCell } from '../components/StatusCell';

const STATUS_ITEM_BG_OPACITY_HEX = '14'; // Alpha opacity 8%

export const StatusDiv = styled.div`
  display: inline-flex;
  padding: 2px 16px 2px 10px;
  align-items: center;
  gap: 8px;
  border-radius: 12px;

  & .label {
    color: inherit !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: inherit !important;
    text-transform: capitalize;
  }
`;

export const girRebootChildren = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const chargingChildrenKeys = {
  NOT_CONNECTED: 'NOT_CONNECTED',
  CONNECTED_CHARGING: 'CONNECTED_CHARGING',
  FAULTED: 'FAULTED',
  CONNECTED_NOT_CHARGING: 'CONNECTED_NOT_CHARGING',
  UNKNOWN: 'UNKNOWN',
  RESERVED_CABLE_DISCONNECTED: 'RESERVED_CABLE_DISCONNECTED',
}

export const chargingChildren = [
  { value: chargingChildrenKeys.NOT_CONNECTED, label: 'Cable Disconnected' },
  { value: chargingChildrenKeys.CONNECTED_CHARGING, label: 'Charging' },
  { value: chargingChildrenKeys.FAULTED, label: 'Faulted' },
  { value: chargingChildrenKeys.CONNECTED_NOT_CHARGING, label: 'Cable Connected, Not Charging' },
  { value: chargingChildrenKeys.UNKNOWN, label: 'Unknown' },
  { value: chargingChildrenKeys.RESERVED_CABLE_DISCONNECTED, label: 'Cable Disconnected, Reserved' },
];

export const chargerStateLabels = chargingChildren
  .sort((a, b) => sortingLowerCase(a, b, 'label'))
  .reduce((acc, { value, label }) => ({ ...acc, [value]: label }), {});

export const yesNoChildren = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const productType = [
  { value: 'RHCP', label: 'RHCP' },
  { value: 'DQC', label: 'DQC' },
];

export const noPlazaOptions = [{ value: 'no_plazas', label: 'No Plazas Available', disabled: true }];

export const StatusLabel = ({ status }) => {
  if (!status) {
    return null;
  }

  const statusItem = allChargerStatuses.find((item) => item.key.toLowerCase() === status.toLowerCase());

  if (!statusItem) {
    return null;
  }

  const { label, Icon, color } = statusItem;

  return (
    <StatusDiv
      style={{
        color,
        backgroundColor: `${color}${STATUS_ITEM_BG_OPACITY_HEX}`, // Alpha opacity 8%
      }}
      className="label__status"
    >
      <Icon />
      <span className="label__text">{label}</span>
    </StatusDiv>
  );
};

export const statusMenuItems = (monitored = false, isStatic = false) => {
  const items = monitored ? monitoredStatuses : chargerStatuses;

  return sortBy(items, ['label']).map((item) => {
    const label = isStatic ? <StatusLabel status={item.key} /> : <StatusCell status={item.key} inDropdown />;

    return { value: item.key.toUpperCase(), label };
  });
};

export const cConditionOptions = (mode, inDropdown = false, isStatic = false, isPending = false) => {
  const conditions =
    ['create', 'view'].includes(mode) || isPending ? conditionStatuses : conditionStatuses.filter(({ key }) => key !== 'pending');

  return conditions.map(({ key, label }) => {
    const className = `c_condition-label-${key}`;
    const labelLayout = isStatic ? (
      <StatusLabel status={key} />
    ) : (
      <StatusCell labelClassName={className} labelText={label} inDropdown={inDropdown} />
    );

    return { value: key, label: labelLayout };
  });
};

export const cChargingOptions = () =>
  chargingChildren.map(({ value }) => ({
    value,
    label: <StatusLabel status={value} />,
  }));

